module.exports = __webpack_public_path__ + "img/CreativeBC-BCID-ArtsCouncil-lockup_rgb_rev.98bfd091.png";